<template>
  <div class="modal fade" ref="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Выбор нового отряда</h5>
          <button type="button" class="close" @click="close">
            <span>&times;</span>
          </button>
        </div>

        <div class="modal-body">

          <div class="mb-2">
            <div v-if="currentSquad">
              #{{ currentSquad.id }} {{ currentSquad.name }}
              <span class="badge badge-secondary">Сейчас назначен</span>
            </div>
            <div v-else>—</div>
          </div>

          <div class="mb-3">
            <input type="text" class="form-control" v-model="searchQuery" placeholder="Поиск по названию или ID...">
          </div>

          <div v-if="loading" class="text-center my-2">
            <i class="fas fa-spinner fa-spin"></i> Загрузка...
          </div>

          <div class="list-group mb-3" v-else>
            <div
                v-for="squad in squads"
                :key="squad.id"
                @click="!isCurrentSquad(squad) && selectSquad(squad)"
                class="list-group-item list-group-item-action"
                :class="{
                active: selectedSquad && selectedSquad.id === squad.id,
                disabled: isCurrentSquad(squad)
              }"
                :style="isCurrentSquad(squad) ? 'cursor: not-allowed; opacity: 0.6;' : ''"
            >
              #{{ squad.id }} {{ squad.name }}
              <span v-if="isCurrentSquad(squad)" class="ml-2 badge badge-secondary">Сейчас назначен</span>
            </div>
            <div v-if="!squads.length && !loading" class="text-muted text-center mt-2">
              Нет результатов
            </div>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary"
                  :disabled="!selectedSquad || isCurrentSquad(selectedSquad)"
                  @click="confirm">
            Подтвердить
          </button>
          <button type="button" class="btn btn-secondary" @click="close">Отмена</button>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      squads: [],
      currentSquad: null,
      selectedSquad: null,
      searchQuery: '',
      loading: false,
      callId: null
    };
  },
  watch: {
    searchQuery: 'fetchSquadsDebounced'
  },
  methods: {
    openModal(callId, currentSquad) {
      this.callId = callId;
      this.currentSquad = currentSquad;
      this.selectedSquad = null;
      this.searchQuery = '';
      this.fetchSquads();
      $(this.$refs.modal).modal('show');
    },
    close() {
      $(this.$refs.modal).modal('hide');
    },
    selectSquad(squad) {
      this.selectedSquad = squad;
    },
    confirm() {
      this.$emit('confirm', this.selectedSquad);
      this.close();
    },
    isCurrentSquad(squad) {
      return this.currentSquad && squad.id === this.currentSquad.id;
    },
    fetchSquads() {
      if (!this.callId) return;
      this.loading = true;
      axiosGetValue('/api/admin/client-call/get-active-squads', {
        id: this.callId,
        query: this.searchQuery
      }, res => {
        this.squads = res;
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    },
    fetchSquadsDebounced: debounce(function() {
      this.fetchSquads();
    }, 300)
  }
};
</script>